import { render, staticRenderFns } from "./MenuComponent.vue?vue&type=template&id=bdc5f1a0&scoped=true&lang=html&"
import script from "./MenuComponent.vue?vue&type=script&lang=js&"
export * from "./MenuComponent.vue?vue&type=script&lang=js&"
import style0 from "./MenuComponent.vue?vue&type=style&index=0&id=bdc5f1a0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc5f1a0",
  null
  
)

export default component.exports